<template>
  <div v-if="isVisiblePdfU" class="modal-overlay">
    <div class="modal-content">
      <h3 class="title">Editar Archivo PDF</h3>
      <form @submit.prevent="submitPdf">
        <div class="form-group">
          <label for="fileName">Nombre del Archivo</label>
          <input
            type="text"
            id="fileName"
            v-model="fileName"
            placeholder="Nombre del archivo"
          />
        </div>

        <div class="form-group">
          <label for="category">Categoría</label>
          <select id="category" v-model="category">
            <option value="" disabled>Selecciona un tipo de archivo</option>
            <option value="NONE">NONE</option>
            <!-- <option value="CDM Overview">CDM Overview</option> -->
            <!-- <option value="Conference Call">Conference Call</option> -->
            <!-- <option value="Presentation">Presentation</option> -->
            <option value="Offering Memorandum">Offering Memorandum</option>
            <option value="Financial Statements">Financial Statements</option>
            <!-- <option value="Ratings">Ratings</option> -->
            <option value="Public ESG">ESG / ASG</option>
            <option value="Public Operations">Operations / Operaciones</option>
            <option value="Public Location">Public Location</option>
            <option value="Public History">Public History</option>
            <option value="Public About Us">Public About Us</option>
            <option value="General">Inicio / Home</option>
          </select>
        </div>

        <div class="form-group">
          <label for="quarter">Trimestre</label>
          <select id="quarter" v-model="quarter">
            <option value="" disabled>Selecciona un trimestre</option>
            <option value="Q1">1</option>
            <option value="Q2">2</option>
            <option value="Q3">3</option>
            <option value="Q4">4</option>
          </select>
        </div>

        <div class="form-group">
          <label for="year">Año</label>
          <input type="number" id="year" v-model="year" placeholder="Año" />
        </div>

        <!-- <div class="form-group">
          <label for="pdf">Nuevo Archivo </label>
          <input
            type="file"
            id="pdf"
            accept="application/pdf , application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
            @change="handleFileChange"
          />
          <div v-if="file" class="text-green">
            Archivo seleccionado: {{ file }}
          </div>
        </div> -->

        <div style="display: flex; justify-content: flex-end">
          <button type="submit" :disabled="isSubmitting" :class="{'btn-disabled': isSubmitting}">Guardar cambios</button>
          <button type="button" @click="closeModal">Cerrar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { showErrorToast, showInfoToast, showSuccessToast } from "@/kernel/alerts";
import { updateFileService } from "../services/files-service";

export default {
  props: {
    isVisiblePdfU: {
      type: Boolean,
      required: true,
    },
    fileToEdit: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pdfFile: null,
      fileName: "",
      category: "",
      quarter: "",
      year: "",
      file: "",
      isSubmitting: false,
    };
  },
  watch: {
    fileToEdit: {
      handler(newVal) {
        if (newVal && typeof newVal === "object") {
          this.fileName = newVal.file_name || "";
          this.category = newVal.category || "";
          this.quarter = newVal.quarter || "";
          this.year = newVal.year || "";
        }
      },
      immediate: true,
    },
  },

  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      if ((file && file.type === "application/pdf") ||
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "text/csv") {
        this.pdfFile = file;
        this.file = file.name;
      } else {
        alert("Solo se permiten archivos PDF.");
        this.pdfFile = null;
        this.file = "";
      }
    },
    closeModal() {
      this.$emit("update:visible", false);
      this.pdfFile = null;
      this.fileName = "";
      this.category = "";
      this.quarter = "";
      this.year = "";
      this.file = "";
    },
    async submitPdf() {
      this.isSubmitting = true;
      showInfoToast("Subiendo archivo...");
      if (!this.fileName || !this.category || !this.quarter || !this.year) {
        showErrorToast("Por favor, completa todos los campos.");
        this.isSubmitting = false;
        return;
      }

      const formData = new FormData();
      if (this.pdfFile) {
        formData.append("file", this.pdfFile);
      }
      formData.append("fileName", this.fileName);
      formData.append("category", this.category);
      formData.append("quarter", this.quarter);
      formData.append("year", this.year);
      formData.append("id", this.fileToEdit.id);

      try {
        const result = await updateFileService(formData);
        if (result.status === 200) {
          showSuccessToast("Archivo actualizado correctamente.");
          this.$emit("update:files");
          this.closeModal();
          this.isSubmitting = false;
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
      } finally {
        this.isSubmitting = false;
      }
      
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  max-width: 100%;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input,
select {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

button {
  padding: 10px 15px;
  margin-top: 10px;
  cursor: pointer;
  background-color: orange;
  color: white;
  border: none;
  border-radius: 16px;
}

button[type="submit"]:hover {
  background-color: yellowgreen;
}

button[type="button"] {
  margin-left: 16px;
  background-color: darkgray;
}

button[type="button"]:hover {
  background-color: gray;
}

.title {
  margin-top: 0;
  color: orange;
}

.text-green {
  color: green;
  font-weight: bold;
  margin-top: 8px;
}
.btn-disabled {
  background-color: #ccc !important;
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
